export interface DishesSettings {
  dishesList: [
    {
      id: Number;
      offeringType: String;
      price: String;
      name?: any;
      description?: any;
    },
  ];

  pagination: {
    pageSize: number;
    currentPage: number;
  };
  total: number;
  showLoadMoreButton: boolean;

  showSearchBar: boolean;
  searchItem: string;
  filterTagList: any;
}
export default {
  pagination: {
    pageSize: 999999,
    currentPage: 1,
  },
  showLoadMoreButton: true,

  showSearchBar: false,
  filterTagList: [],
} as DishesSettings;

export const spaceName = 'caDishes';
